"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIClientFactory = void 0;
var APIClient_1 = require("./APIClient");
var HTTPClient_1 = require("./HTTPClient");
var APIClientFactory = /** @class */ (function () {
    function APIClientFactory(httpClientConfig) {
        var _this = this;
        this.httpClientConfig = httpClientConfig;
        this.getHTTPClient = function (_a) {
            var accessToken = _a.accessToken;
            return new HTTPClient_1.HTTPClient(__assign(__assign({}, _this.httpClientConfig), { accessToken: accessToken }));
        };
        this.getAPIClient = function (_a) {
            var accessToken = _a.accessToken;
            var httpClient = _this.getHTTPClient({ accessToken: accessToken });
            return new APIClient_1.APIClient(httpClient);
        };
    }
    APIClientFactory.inject = function () { return [
        HTTPClient_1.HTTPClientConfig
    ]; };
    return APIClientFactory;
}());
exports.APIClientFactory = APIClientFactory;
//# sourceMappingURL=APIClientFactory.js.map